import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="app-header">
      <h1>Willkommen</h1>
      <img src="/hf_icon.png" alt="Logo" className="header-logo" />
    </header>
  );
};

export default Header;
